import React, { useState } from "react";
import "./LeadNewContent.css";
import Modal from "react-modal";

function LeadNewContent(props) {
  const [leadVal, setLeadVal] = useState("l_aspirational");
  const [showModal, setShowModal] = useState(false);
  const [activeModal, setActiveModal] = useState("");

  React.useEffect(() => {
    setLeadVal(props.menu2);
  }, [props.menu2]);

  const handleOpenModal = (val) => {
    setActiveModal(val);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setShowModal("");
  };
  return (
    <>
      <div className="lead-container">
        <div className="lead-wrap">
          {/* <h2 className='main-head'>Executive Enablement - <span className='sub-head'>Evolving dynamically with innovative offerings to lead change</span></h2> */}
          {/* <h2 className='main-head'><span className='sub-head'>Evolve dynamically with innovative, market-fit, customized learning offerings, enabling our executives to lead change.</span></h2> */}

          <div className="lead-row row1">
            <h2>Browse by Category</h2>
            <div className="lead-box">
              <div
                class="nav flex-column nav-pills"
               
                role="tablist"
                aria-orientation="vertical"
              >
                <button
                  class={
                    leadVal === "l_technology" ? "nav-link active" : "nav-link"
                  }
                  id="v-pills-Technology-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#v-pills-Technology"
                  type="button"
                  role="tab"
                  aria-controls="v-pills-Technology"
                  aria-selected="false"
                  onClick={() => setLeadVal("l_technology")}
                >
                  Technology
                </button>
                <button
                  class={leadVal === "l_human" ? "nav-link active" : "nav-link"}
                  id="v-pills-Human-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#v-pills-Human"
                  type="button"
                  role="tab"
                  aria-controls="v-pills-Human"
                  aria-selected="false"
                  onClick={() => setLeadVal("l_human")}
                >
                  Innovation & Human Skills
                </button>
                <button
                  class={
                    leadVal === "l_design" ? "nav-link active" : "nav-link"
                  }
                  id="v-pills-Design-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#v-pills-Design"
                  type="button"
                  role="tab"
                  aria-controls="v-pills-Design"
                  aria-selected="false"
                  onClick={() => setLeadVal("l_design")}
                >
                  Delivery
                </button>
                <button
                  class={
                    leadVal === "l_aspirational"
                      ? "nav-link active"
                      : "nav-link"
                  }
                  id="v-pills-Aspirational-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#v-pills-Aspirational"
                  type="button"
                  role="tab"
                  aria-controls="v-pills-Aspirational"
                  aria-selected="true"
                  onClick={() => setLeadVal("l_aspirational")}
                >
                  Specializations{" "}
                </button>
              </div>
            </div>
          </div>
          <div className="lead-row row2">
            {/* <h2 className='main-head'>Executive Enablement</h2>
                    <p className='sub-head'>Evolving dynamically with innovative offerings to lead change</p> */}
            <h2 className="main-head">
              <span className="sub-head">
                Evolve dynamically with innovative, market-fit, customized
                learning offerings, enabling our executives to lead change.
              </span>
            </h2>
            <div className="lead-box">
              <div class="tab-content">
                <div
                  class={
                    leadVal === "l_design"
                      ? "tab-pane fade show active"
                      : "tab-pane fade"
                  }
                  id="v-pills-Design"
                  role="tabpanel"
                  aria-labelledby="v-pills-Design-tab"
                >
                  <div className="change-container">
                    <div className="change-wrap">
                      <div
                        className={
                          props.menu3 === "DeliveryLeadPractitionerSchool"
                            ? "change-row highlight-search"
                            : "change-row"
                        }
                      >
                        <div className="change-box">
                          <h3>
                            Delivery Lead <br /> Practitioner School
                          </h3>
                          <p>
                            Provides a 360-degree view of knowledge, skills, and
                            mindset essential to lead challenging delivery
                            engagements
                          </p>
                          <p>
                            <a
                              href="mailto:gajendra.mallik" aria-label="mailto:gajendra.mallik"
                              className="left-side-link"
                              target="_blank"
                            >
                              <img
                                src="images/Offerings/mail-icon-normal.png"
                                alt=""
                              />
                            </a>
                            <a
                              className="right-side-link"
                              href="https://atci.lkm.delivery.accenture.com/leadershipprograms/DLPS"
                              target="_blank"
                            >
                              Explore More{" "}
                              <img
                                src="images/Home/Explore arrow.png"
                                alt=""
                              />
                            </a>
                          </p>
                          <img
                            src="images/Offerings/latest-label-tag.gif"
                            alt="new-label"
                            className="new-label-img"
                          />
                        </div>
                      </div>
                      <div
                        className={
                          props.menu3 === "DeliverySalesAcademy"
                            ? "change-row highlight-search"
                            : "change-row"
                        }
                      >
                        <div className="change-box">
                          <h3>Delivery Sales Academy</h3>
                          <p>
                            Designed to originate sales opportunities by
                            building upon client relationships and effective
                            positioning of Accenture offerings
                          </p>
                          <p>
                            <a
                              href="mailto:gajendra.mallik" aria-label="mailto:gajendra.mallik"
                              className="left-side-link"
                              target="_blank"
                            >
                              <img
                                src="images/Offerings/mail-icon-normal.png"
                                alt=""
                              />
                            </a>
                            <a
                              className="right-side-link"
                              href="https://atci.lkm.delivery.accenture.com/leadershipprograms/DSA"
                              target="_blank"
                            >
                              Explore More{" "}
                              <img
                                src="images/Home/Explore arrow.png"
                                alt=""
                              />
                            </a>
                          </p>
                          <img
                            src="images/Offerings/latest-label-tag.gif"
                            alt="new-label"
                            className="new-label-img"
                          />
                        </div>
                      </div>
                      <div
                        className={
                          props.menu3 === "MITOMasterClass"
                            ? "change-row highlight-search"
                            : "change-row"
                        }
                      >
                        <div className="change-box">
                          <h3>MITO Master Class</h3>
                          <p>
                            Enables contract delivery leads to drive greater
                            productivity and profitability for AO-IO contracts
                          </p>
                          <p>
                            <a
                              href="mailto:gajendra.mallik" aria-label="mailto:gajendra.mallik"
                              className="left-side-link"
                              target="_blank"
                            >
                              <img
                                src="images/Offerings/mail-icon-normal.png"
                                alt=""
                              />
                            </a>
                            <a
                              className="right-side-link"
                              href="https://atci.lkm.delivery.accenture.com/leadershipprograms/MITO"
                              target="_blank"
                            >
                              Explore More{" "}
                              <img
                                src="images/Home/Explore arrow.png"
                                alt=""
                              />
                            </a>
                          </p>
                          <img
                            src="images/Offerings/latest-label-tag.gif"
                            alt="new-label"
                            className="new-label-img"
                          />
                        </div>
                      </div>
                      <div
                        className={
                          props.menu3 === "SIFoundationclassforDeliveryManagers"
                            ? "change-row highlight-search"
                            : "change-row"
                        }
                      >
                        <div className="change-box">
                          <h3>SI Foundation class for Delivery Managers</h3>
                          <p>
                            Designed to help delivery managers grow and manage
                            the SI projects in the NEW
                          </p>
                          <p>
                            <a
                              href="mailto:gajendra.mallik" aria-label="mailto:gajendra.mallik"
                              className="left-side-link"
                              target="_blank"
                            >
                              <img
                                src="images/Offerings/mail-icon-normal.png"
                                alt=""
                              />
                            </a>
                            <a
                              className="right-side-link"
                              href="https://atci.lkm.delivery.accenture.com/SystemIntegration/SIFC"
                              target="_blank"
                            >
                              Explore More{" "}
                              <img
                                src="images/Home/Explore arrow.png"
                                alt=""
                              />
                            </a>
                          </p>
                          <img
                            src="images/Offerings/latest-label-tag.gif"
                            alt="new-label"
                            className="new-label-img"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="change-wrap">
                      <div
                        className={
                          props.menu3 === "SIMasterClass"
                            ? "change-row highlight-search"
                            : "change-row"
                        }
                      >
                        <div className="change-box">
                          <h3>SI Master Class</h3>
                          <p>
                            A flagship leadership training program that
                            strengthens key areas of an SI engagement - Scope
                            and Contract Management, Stakeholder Management, and
                            Financials Management
                          </p>
                          <p>
                            <a
                              href="mailto:gajendra.mallik" aria-label="mailto:gajendra.mallik"
                              className="left-side-link"
                              target="_blank"
                            >
                              <img
                                src="images/Offerings/mail-icon-normal.png"
                                alt=""
                              />
                            </a>
                            <a
                              className="right-side-link"
                              href="https://atci.lkm.delivery.accenture.com/SystemIntegration/MasterClass"
                              target="_blank"
                            >
                              Explore More{" "}
                              <img
                                src="images/Home/Explore arrow.png"
                                alt=""
                              />
                            </a>
                          </p>
                          <img
                            src="images/Offerings/latest-label-tag.gif"
                            alt="new-label"
                            className="new-label-img"
                          />
                        </div>
                      </div>
                      <div
                        className={
                          props.menu3 === "SISalesforce"
                            ? "change-row highlight-search"
                            : "change-row"
                        }
                      >
                        <div className="change-box">
                          <h3>SI Salesforce</h3>
                          <p>
                            A flagship training program for Associated Managers
                            and above roles of Salesforce Business group with
                            focus on enhancing end-to-end SI Project Management.
                          </p>
                          <p>
                            <a
                              href="mailto:gajendra.mallik" aria-label="mailto:gajendra.mallik"
                              className="left-side-link"
                              target="_blank"
                            >
                              <img
                                src="images/Offerings/mail-icon-normal.png"
                                alt=""
                              />
                            </a>
                            <a
                              className="right-side-link"
                              href="https://atci.lkm.delivery.accenture.com/SystemIntegration/SISF"
                              target="_blank"
                            >
                              Explore More{" "}
                              <img
                                src="images/Home/Explore arrow.png"
                                alt=""
                              />
                            </a>
                          </p>
                          <img
                            src="images/Offerings/latest-label-tag.gif"
                            alt="new-label"
                            className="new-label-img"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class={
                    leadVal === "l_human"
                      ? "tab-pane fade show active"
                      : "tab-pane fade"
                  }
                  id="v-pills-Human"
                  role="tabpanel"
                  aria-labelledby="v-pills-Human-tab"
                >
                  <div className="change-container">
                    <div className="change-wrap">
                      <div
                        className={
                          props.menu3 === ""
                            ? "change-row highlight-search"
                            : "change-row"
                        }
                      >
                        <div className="change-box">
                          <h3>Agrani</h3>
                          <p>
                            Hyper-personalized Women Mentorship Program for
                            women executives in the Europe market
                          </p>
                          <p>
                            <a
                              href="mailto:fenal.shah" aria-label="mailto:fenal.shah"
                              className="left-side-link"
                              target="_blank"
                            >
                              <img
                                src="images/Offerings/mail-icon-normal.png"
                                alt=""
                              />
                            </a>
                            <a
                              className="right-side-link"
                              href="https://kxdocuments.accenture.com/contribution/7832a2fd-ab01-4007-bd54-b507cde76366"
                              target="_blank"
                            >
                              Know More{" "}
                              <img
                                src="images/Home/Explore arrow.png"
                                alt=""
                              />
                            </a>
                          </p>
                        </div>
                      </div>
                      <div
                        className={
                          props.menu3 === "DesignThinkingAcademy"
                            ? "change-row highlight-search"
                            : "change-row"
                        }
                      >
                        <div className="change-box">
                          <h3>Design Thinking Academy</h3>
                          <p>
                            Design Thinking Academy is for ADs/MDs to initiate a
                            shift towards a human-centered mindset to foster
                            creative thinking, innovation while solving
                            challenges.
                          </p>
                          <p>
                            <a
                              href="mailto:fenal.shah" aria-label="mailto:fenal.shah"
                              className="left-side-link"
                              target="_blank"
                            >
                              <img
                                src="images/Offerings/mail-icon-normal.png"
                                alt=""
                              />
                            </a>
                            <a
                              className="right-side-link"
                              href="https://kxdocuments.accenture.com/contribution/b19d57b5-06cc-4c9c-ad49-e4ebabd9246b"
                              target="_blank"
                            >
                              Know More{" "}
                              <img
                                src="images/Home/Explore arrow.png"
                                alt=""
                              />
                            </a>
                          </p>
                        </div>
                      </div>
                      <div
                        className={
                          props.menu3 === "DrivingClientCentricConnectsDCCC"
                            ? "change-row highlight-search"
                            : "change-row"
                        }
                      >
                        <div className="change-box">
                          <h3>Driving Client Centric Connects (DCCC)</h3>
                          <p>
                            Driving Client Centric Connects (DCCC) aims to help
                            leaders create client-centric narratives and drive
                            strong client partnerships.
                          </p>
                          <p>
                            <a
                              href="mailto:fenal.shah" aria-label="mailto:fenal.shah"
                              className="left-side-link"
                              target="_blank"
                            >
                              <img
                                src="images/Offerings/mail-icon-normal.png"
                                alt=""
                              />
                            </a>
                            <a
                              className="right-side-link"
                              href="https://kxdocuments.accenture.com/contribution/db875457-d7db-4bf4-a86b-2d66c2cedee1"
                              target="_blank"
                            >
                              Know More{" "}
                              <img
                                src="images/Home/Explore arrow.png"
                                alt=""
                              />
                            </a>
                          </p>
                        </div>
                      </div>
                      <div
                        className={
                          props.menu3 === "ValuedrivenClientConversationVDCC"
                            ? "change-row highlight-search"
                            : "change-row"
                        }
                      >
                        <div className="change-box">
                          <h3>Value-driven Client Conversation (VDCC)</h3>
                          <p>
                            Value-driven Client Conversation (VDCC) helps
                            co-create compelling narratives, with real-life
                            simulations of client context and feedback.{" "}
                          </p>
                          <p>
                            <a
                              href="mailto:fenal.shah" aria-label="mailto:fenal.shah"
                              className="left-side-link"
                              target="_blank"
                            >
                              <img
                                src="images/Offerings/mail-icon-normal.png"
                                alt=""
                              />
                            </a>
                            <a
                              className="right-side-link"
                              href="https://kxdocuments.accenture.com/contribution/14c1d399-2d26-46c4-a1ad-39d19c1beab7"
                              target="_blank"
                            >
                              Know More{" "}
                              <img
                                src="images/Home/Explore arrow.png"
                                alt=""
                              />
                            </a>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class={
                    leadVal === "l_aspirational"
                      ? "tab-pane fade show active"
                      : "tab-pane fade"
                  }
                  id="v-pills-Aspirational"
                  role="tabpanel"
                  aria-labelledby="v-pills-Aspirational-tab"
                >
                  <div className="change-container">
                    <div className="change-wrap">
                      <div
                        className={
                          props.menu3 === "ASPIRA"
                            ? "change-row highlight-search"
                            : "change-row"
                        }
                      >
                        <div className="change-box">
                          <h3>ASPIRA FY23</h3>
                          <p>
                            An aspirational program for ATCI execs offering
                            specializations and course collections on Technology
                            for Leaders, Client Centricity, Delivery Leadership,
                            and Sustainability.{" "}
                          </p>
                          <p>
                            <a
                              href="mailto:LKM.Onlinelearning" aria-label="mailto:LKM.Onlinelearning"
                              className="left-side-link"
                              target="_blank"
                            >
                              <img
                                src="images/Offerings/mail-icon-normal.png"
                                alt=""
                              />
                            </a>
                            <a
                              className="right-side-link"
                              href="https://atci.lkm.accenture.com/ASPIRA/home"
                              target="_blank"
                            >
                              Explore More{" "}
                              <img
                                src="images/Home/Explore arrow.png"
                                alt=""
                              />
                            </a>
                          </p>
                          <img
                            src="images/Offerings/latest-label-tag.gif"
                            alt="new-label"
                            className="new-label-img"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class={
                    leadVal === "l_technology"
                      ? "tab-pane fade show active"
                      : "tab-pane fade"
                  }
                  id="v-pills-Technology"
                  role="tabpanel"
                  aria-labelledby="v-pills-Technology-tab"
                >
                  <div className="change-container">
                    <div className="change-wrap">
                      <div
                        className={
                          props.menu3 === "CloudFoundationAcademy"
                            ? "change-row highlight-search"
                            : "change-row"
                        }
                      >
                        <div className="change-box">
                          <h3>Cloud Foundation Academy</h3>
                          <p>
                            This program is exclusively designed for Cloud First
                            D&AI executives to introduce all significant
                            concepts focusing on data and analytics.
                          </p>
                          <p>
                            {" "}
                            <a
                              href="mailto:rahul.suresh.ghali" aria-label="mailto:rahul.suresh.ghali"
                              className="left-side-link"
                              target="_blank"
                            >
                              <img
                                src="images/Offerings/mail-icon-normal.png"
                                alt=""
                              />
                            </a>
                          </p>
                          <div onClick={() => handleOpenModal("image1")}>
                            <a className="right-side-link" tabIndex={0}>
                              View More{" "}
                              <img
                                src="images/Home/Explore arrow.png"
                                alt=""
                              />
                            </a>
                          </div>
                          <Modal
                            isOpen={showModal && activeModal === "image1"}
                            onRequestClose={() => setShowModal(false)}
                            // contentLabel="login Modal"
                            style={{
                              overlay: {
                                backgroundColor: "rgba(0, 0, 0, 0.75)",
                              },
                            }}
                          >
                            <button
                              className="closebtn"
                              onClick={handleCloseModal}
                            >
                              X
                            </button>
                            <h3>Data Foundation Academy</h3>
                            <p>
                              Data Foundation Academy is a curated set of
                              learning specifically focused on executives – SM &
                              above in D&AI to introduce all major concepts
                              focusing on Data and Analytics on the cloud. The 3
                              main take-aways from this program:
                            </p>
                            <ul>
                              <li>
                                Understand all the building blocks that form an
                                end-to-end Data Ecosystem
                              </li>
                              <li>
                                Ability to strike informed conversations with
                                clients and project teams on Data on Cloud
                                deals/ongoing assignments across 3 major cloud
                                providers – GCP, AWS & Azure{" "}
                              </li>
                              <li>
                                Understand relevant Accenture Data on Cloud
                                assets to help drive growth either for new or
                                existing opportunity
                              </li>
                            </ul>
                            <button
                              className="close"
                              onClick={handleCloseModal}
                            >
                              Close
                            </button>
                          </Modal>
                        </div>
                      </div>
                      <div
                        className={
                          props.menu3 === "DataonCloudPrimer"
                            ? "change-row highlight-search"
                            : "change-row"
                        }
                      >
                        <div className="change-box">
                          <h3>Data on Cloud Primer</h3>
                          <p>
                            Data on Cloud Primer provides a panoramic view of
                            Data Services on AWS, GCP and Azure, and provides
                            insights on data migration from on-premise to cloud.
                          </p>
                          <p>
                            {" "}
                            <a
                              href="mailto:rahul.suresh.ghali" aria-label="mailto:rahul.suresh.ghali"
                              className="left-side-link"
                              target="_blank"
                            >
                              <img
                                src="images/Offerings/mail-icon-normal.png"
                                alt=""
                              />
                            </a>
                          </p>
                          <div onClick={() => handleOpenModal("image2")}>
                            <a className="right-side-link" tabIndex={0}>
                              View More{" "}
                              <img
                                src="images/Home/Explore arrow.png"
                                alt=""
                              />
                            </a>
                          </div>
                          <Modal
                            isOpen={showModal && activeModal === "image2"}
                            onRequestClose={() => setShowModal(false)}
                            // contentLabel="login Modal"
                            style={{
                              overlay: {
                                backgroundColor: "rgba(0, 0, 0, 0.75)",
                              },
                            }}
                          >
                            <button
                              className="closebtn"
                              onClick={handleCloseModal}
                            >
                              X
                            </button>
                            <h3>Data on Cloud Primer</h3>
                            <p>
                              Data on Cloud Primer is a training program
                              designed for executives at ATCi. It focouses on
                              the following
                            </p>
                            <ul>
                              <li>Data Ingestion</li>
                              <li>Data Storage</li>
                              <li>Data Processing</li>
                              <li>Data Analysis</li>
                              <li>Data Migration</li>
                              <li>Data Landscape</li>
                            </ul>
                            <p>
                              This program provides experiential learning with
                              the help of well-curated case studies across AWS,
                              Azure and GCP Cloud Platforms.
                            </p>
                            <button
                              className="close"
                              onClick={handleCloseModal}
                            >
                              Close
                            </button>
                          </Modal>
                        </div>
                      </div>
                      <div
                        className={
                          props.menu3 === ""
                            ? "change-row highlight-search"
                            : "change-row"
                        }
                      >
                        <div className="change-box">
                          <h3>Demystifying AI</h3>
                          <p>
                            Demystifying the world of Artificial Intelligence,
                            why it's important, where it's heading and what it
                            means
                          </p>
                          <p>
                            <a
                              href="mailto:shantanu.a.biswas" aria-label="mailto:shantanu.a.biswas"
                              className="left-side-link"
                              target="_blank"
                            >
                              <img
                                src="images/Offerings/mail-icon-normal.png"
                                alt=""
                              />
                            </a>
                          </p>
                          <div onClick={() => handleOpenModal("image4")}>
                            <a className="right-side-link" tabIndex={0}>
                              View More{" "}
                              <img
                                src="images/Home/Explore arrow.png"
                                alt=""
                              />
                            </a>
                          </div>
                          <Modal
                            isOpen={showModal && activeModal === "image4"}
                            onRequestClose={() => setShowModal(false)}
                            // contentLabel="login Modal"
                            style={{
                              overlay: {
                                backgroundColor: "rgba(0, 0, 0, 0.75)",
                              },
                            }}
                          >
                            <button
                              className="closebtn"
                              onClick={handleCloseModal}
                            >
                              X
                            </button>
                            <h3 role="heading" aria-level="2">Demystifying AI</h3>
                            <p>
                              A workshop designed specially for senior
                              executives covering the breadth of AI, including:
                            </p>
                            <ul>
                              <li>The basics of artificial intelligence</li>
                              <li>Various machine learning algorithms</li>
                              <li>Chatbots</li>
                              <li>Deep learning</li>
                            </ul>
                            <button
                              className="close"
                              onClick={handleCloseModal}
                            >
                              Close
                            </button>
                          </Modal>
                        </div>
                      </div>
                      <div
                        className={
                          props.menu3 === ""
                            ? "change-row highlight-search"
                            : "change-row"
                        }
                      >
                        <div className="change-box">
                          <h3>Her Cloud</h3>
                          <p>
                            Upskilling women on the latest Cloud-First skills to
                            enable them to become future leaders
                          </p>
                          <p>
                            <a
                              href="mailto:rahul.suresh.ghali" aria-label="mailto:rahul.suresh.ghali"
                              className="left-side-link"
                              target="_blank"
                            >
                              <img
                                src="images/Offerings/mail-icon-normal.png"
                                alt=""
                              />
                            </a>
                          </p>
                          <div onClick={() => handleOpenModal("image3")}>
                            <a className="right-side-link" tabIndex={0}>
                              View More{" "}
                              <img
                                src="images/Home/Explore arrow.png"
                                alt=""
                              />
                            </a>
                          </div>
                          <Modal
                            isOpen={showModal && activeModal === "image3"}
                            onRequestClose={() => setShowModal(false)}
                            // contentLabel="login Modal"
                            style={{
                              overlay: {
                                backgroundColor: "rgba(0, 0, 0, 0.75)",
                              },
                            }}
                          >
                            <button
                              className="closebtn"
                              onClick={handleCloseModal}
                            >
                              X
                            </button>
                            <h3>Her Cloud</h3>
                            <p>
                              Her Cloud Career is a cloud program specially
                              designed to hire women technologists to equip them
                              to take leaps in their careers with Accenture,
                              learn the latest Cloud First skills to unlock 360°
                              value for businesses, and become leaders of the
                              future.
                            </p>
                            <p>Three key pillars of the program entail:</p>
                            <ul>
                              <li>
                                Hiring - Opportunities with Cloud First at the
                                associate manager, manager, senior manager, and
                                associate director career levels
                              </li>
                              <li>
                                Learning - Access to Cloud Learning Academy and
                                certification opportunities on key cloud skills
                              </li>
                              <li>
                                Mentoring - Mentorship by the best minds and
                                thought leaders and a unique opportunity to
                                network and be mentors
                              </li>
                            </ul>
                            <button
                              className="close"
                              onClick={handleCloseModal}
                            >
                              Close
                            </button>
                          </Modal>
                        </div>
                      </div>
                    </div>
                    <div className="change-wrap">
                      <div
                        className={
                          props.menu3 ===
                          "QualityEngineeringExecutiveProgramQEEP"
                            ? "change-row highlight-search"
                            : "change-row"
                        }
                      >
                        <div className="change-box">
                          <h3>Quality Engineering Executive Program (QEEP)</h3>
                          <p>
                            QEEP - Testing in Cloud Workshop is specially
                            curated for Managers, interested in exploring and
                            learning various cloud application testing
                            techniques
                          </p>
                          <p>
                            <a
                              href="mailto:sheela.t.ganesh" aria-label="mailto:sheela.t.ganesh"
                              className="left-side-link"
                              target="_blank"
                            >
                              <img
                                src="images/Offerings/mail-icon-normal.png"
                                alt=""
                              />
                            </a>
                            <a
                              className="right-side-link"
                              href="https://deepknowledge.accenture.com/enrol/index.php?id=601"
                              target="_blank"
                            >
                              Explore More{" "}
                              <img
                                src="images/Home/Explore arrow.png"
                                alt=""
                              />
                            </a>
                          </p>
                        </div>
                      </div>
                      <div
                        className={
                          props.menu3 === "SAPTQforLeaders"
                            ? "change-row highlight-search"
                            : "change-row"
                        }
                      >
                        <div className="change-box">
                          <h3>SAP TQ for Leaders</h3>
                          <p>
                            SAPQ is a curated learning board to strengthen
                            personal knowledge of transformative technologies
                            and have meaningful conversations around SAP while
                            delivering 360˚ value.
                          </p>
                          <p>
                            <a
                              href="mailto:praveen.rajaram" aria-label="mailto:praveen.rajaram"
                              className="left-side-link"
                              target="_blank"
                            >
                              <img
                                src="images/Offerings/mail-icon-normal.png"
                                alt=""
                              />
                            </a>
                            <a
                              className="right-side-link"
                              href="https://deepknowledge.accenture.com/home/sap-leader-series"
                              target="_blank"
                            >
                              Explore More{" "}
                              <img
                                src="images/Home/Explore arrow.png"
                                alt=""
                              />
                            </a>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default LeadNewContent;
